
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import FormPago from "./FormPago.vue"
import { DateTime } from "luxon";
  
  @Component({
    name: "PagosIndex",
    components: { FormPago}
  })
  export default class PagosIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    public dialog = false;
    public fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
    public txtSearch = '';
    public pago_selected = null;
    swEditar = false
    mounted(){
      this.getPagos();
    }
    getPagos(){
      this.loading
      let data = {
        fecha_inicial: this.fechaInicial,
        fecha_final: this.fechaFinal,
        txtSearch: this.txtSearch
      }
      this.consultorioService.getPagos(data)
    }
    editar(pago:any){
      this.swEditar = true;
      this.pago_selected = pago
    }
    nuevoPago(){
        this.dialog = true;
    }
    close(){
        this.dialog = false;
    }
    
    get pagos(): any {
      return this.consultorioStore.pagos;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }


    
  }
  